import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import spreadsheetValidations from './spreadsheetValidations'

export class CheckAvailableModal extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    let invalid = this.props.grid

    const invalidData = invalid.filter(crf =>
      spreadsheetValidations.releasedDate(crf[5].value)
    )

    const gridWithInput = this.props.grid.filter(
      crf => crf[5].value !== '' && crf[5].value !== 'Released Date'
    )

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Released</h4>
                        <h5 className='returnHeader'>
                          Are you sure you want to proceed? Please confirm.
                        </h5>
                      </>
                    ) : (
                      <h4>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => (
                  <div className='updatingChecksContent'>
                    <div className='inProcessCrfDetail'>
                      <span>CRF#:{crf[1].value}</span>
                    </div>

                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          crf[5].value === '' ||
                          spreadsheetValidations.releasedDate(crf[5].value)
                            ? textRed
                            : null
                        }
                      >
                        Released Date:
                        {crf[5].value === ''
                          ? 'Empty'
                          : spreadsheetValidations.releasedDate(crf[5].value)
                          ? 'Invalid'
                          : crf[5].value.trim()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>Date must be valid and in mm/dd/yy format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckReleased}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default CheckAvailableModal
